import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import {Card, Col} from 'react-bootstrap';

const CardSkeleton = ({count = 1}) => {
  return (
    <>
      {Array(count).fill().map((_, index) => (
        <Col key={index} className="p-2">
          <Card className="edge-card">
            <Card.Body>
              <div className="header">
                <div>
                  <h5>
                    <Skeleton width={400} height={24}/>
                  </h5>
                </div>
                <div>
                  <Skeleton width={100} height={30}/>
                </div>
              </div>
              <small>
                <Skeleton width={200}/>
              </small>
              <div className="d-flex flex-column scc-info">
                <div className="d-flex justify-content-between">
                  <Skeleton width={80}/>
                  <Skeleton width={120}/>
                </div>
                <div className="d-flex justify-content-between">
                  <Skeleton width={80}/>
                  <Skeleton width={120}/>
                </div>
                <div className="d-flex justify-content-between">
                  <Skeleton width={80}/>
                  <Skeleton width={120}/>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </>
  );
};

export default CardSkeleton;
